import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import ComicsHeader from './components/ComicsHeader';
import ComicsGrid from './components/ComicsGrid';

export default function Comics() {
  usePageMeta(
    '漫画库 - 分类浏览与收藏连载漫画 | 我爱漫画网',
    '我爱漫画网漫画库，支持按热血冒险、科幻奇幻、恋爱日常、悬疑惊悚、搞笑治愈等分类筛选与搜索，一键收藏连载漫画并开启更新提醒。'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <ComicsHeader />
        <ComicsGrid />
      </main>
      <Footer />
    </div>
  );
}